import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-950 mt-6">页面未找到</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">该页面尚未生成，请确认网址是否正确</p>
        <a href="/" className="mt-6 inline-block px-5 py-2.5 bg-primary-500 text-white rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
          返回首页
        </a>
      </div>
    </div>
  );
}